import { Action } from 'redux';
import { AsyncState } from '../../async/state/types';
import { CollectionSyncState, ResultsCollection, SyncState } from '../../sync/state/types';

export type Reducer<State> = (state: State, action: Action) => State;

export function joinReducers<T>(
	reducers: (Reducer<AsyncState<T>> | Reducer<SyncState<T>>)[],
	defaultState: AsyncState<T>
): Reducer<AsyncState<T>> {
	return function(state = defaultState, action) {
		let currentState = state;

		for (let i = 0; i < reducers.length; i++) {
			currentState = reducers[ i ](currentState, action) as AsyncState<T>;
		}

		return currentState;
	};
}

export function joinCollectionReducers<T>(
	reducers: (Reducer<AsyncState<ResultsCollection<T>>> | Reducer<CollectionSyncState<T>>)[],
	defaultState: AsyncState<ResultsCollection<T>>
): Reducer<AsyncState<ResultsCollection<T>>> {
	return function(state = defaultState, action) {
		let currentState = state;

		for (let i = 0; i < reducers.length; i++) {
			currentState = reducers[ i ](currentState, action) as AsyncState<ResultsCollection<T>>;
		}

		return currentState;
	};
}

export function joinSyncCollectionReducers<T>(
	reducers: Reducer<CollectionSyncState<T>>[],
	defaultState: CollectionSyncState<T>
): Reducer<CollectionSyncState<T>> {
	return function(state = defaultState, action) {
		let currentState = state;

		for (let i = 0; i < reducers.length; i++) {
			currentState = reducers[ i ](currentState, action) as CollectionSyncState<T>;
		}

		return currentState;
	};
}

export function joinSyncReducers<T>(
	reducers: Reducer<SyncState<T>>[],
	defaultState: SyncState<T>
): Reducer<SyncState<T>> {
	return function(state = defaultState, action) {
		let currentState = state;

		for (let i = 0; i < reducers.length; i++) {
			currentState = reducers[ i ](currentState, action) as SyncState<T>;
		}

		return currentState;
	};
}
